import { FormGroup, TextField } from "@mui/material";
import { RewardCalculationTypeEditorProps } from "../../../../types/actionModule/editor/rewardCalculationTypeEditorTypes";
import { useTranslation } from "react-i18next";
import { FixedRewardCalculationTypeModel, isFixedRewardCalculationTypeModel } from "../../../../types/actionModule/rewardCalculationType/fixedRewardCalculationType";

export default function FixedRewardCalculationTypeEditor(props: RewardCalculationTypeEditorProps) {
    const { t } = useTranslation();

    const calculationType = props.value;
    if(!isFixedRewardCalculationTypeModel(calculationType)) {
        return <>Invalid Value</>
    }

    return <FormGroup>
        <TextField
            size="small"
            value={calculationType.reward}
            helperText={t("actionModules.rewardCalculationType.fixed.description")}
            onChange={(e) => props.onChanged({
                ...props.value,
                reward: Number(e.target.value)
            } as FixedRewardCalculationTypeModel)}
            label={t("actionModules.rewardCalculationType.fixed.reward")} variant="outlined"
        />
    </FormGroup>
}